import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async'

const DynamicFavicon = ({ logoUrl, companyName }) => {
  // Only render favicon if logoUrl is provided
  if (!logoUrl) {
    return null
  }

  return (
    <Helmet>
      <link rel='icon' type='image/x-icon' href={logoUrl} />
      <link rel='shortcut icon' type='image/x-icon' href={logoUrl} />
      <link rel='apple-touch-icon' href={logoUrl} />
      <meta name='msapplication-TileImage' content={logoUrl} />
      {companyName && <title>{companyName}</title>}
    </Helmet>
  )
}

DynamicFavicon.propTypes = {
  logoUrl: PropTypes.string,
  companyName: PropTypes.string,
}

export default DynamicFavicon
